import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from './constants';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-cream" data-id="element-150" data-mp="9ll8uwe5pwmz">
      <div className="absolute inset-x-0 top-0 h-[420px] bg-cream-dark/60 -z-10" data-id="element-151" data-mp="4mru70n4vzl8" />
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[720px] h-[720px] rounded-full bg-gold/10 blur-[120px] -z-10" data-id="element-152" data-mp="12a0kra1zryu3" />

      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-153" data-mp="xbpbp1jitscx">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-154" data-mp="sai1kvtwoh33">
          <div className="inline-block px-3 py-1 rounded-full border border-gold bg-cream-light text-burgundy font-semibold text-[10px] sm:text-sm tracking-widest uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-155" data-mp="3d21tk0zn2qpb">
            🎓 Hip Hop Dance Instructor Ready
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold uppercase leading-tight mb-4 sm:mb-6 text-ink" data-id="element-156" data-mp="3j6odfogqqus7">
            Solve an entire year of hip hop dance classes{' '}
            <span className="brush-accent" data-id="element-157" data-mp="39cpfz2rm3z6l">in just 5 minutes.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[280px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-158" data-mp="30i17l3qqq1dk">
          <div className="absolute inset-0 bg-burgundy/10 blur-[70px] rounded-full" data-id="element-159" data-mp="2qlofuber9xlg" />
          <img src="https://cdn.magicpatterns.com/uploads/d6gjhCneYbbQ2oB44R5XBp/Diseno_sin_titulo_(49).png" alt="Hip Hop Dance Instructor Ready — 100 ready-to-teach classes and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-160" data-mp="2vjpvemcz3es6" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-161" data-mp="s3co0h6r7vtq">
          <p className="text-sm sm:text-lg md:text-xl text-ink-soft leading-snug max-w-3xl mx-auto mb-5 sm:mb-7" data-id="element-162" data-mp="ichwoyeni61f">
            100 ready-to-teach hip hop classes with foundations, grooves,
            footwork, freestyle, choreography and performance guidance.
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-163" data-mp="16345wt0e5wd0">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-164" data-mp="112g6biy3k776">
              🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-ink-muted" data-id="element-165" data-mp="3hpse948bhp1i">
            <div className="flex items-center gap-1.5" data-id="element-166" data-mp="1xb5qyhfqoxhp">
              <CheckCircleIcon size={14} className="text-burgundy" data-id="element-167" data-mp="21a4rlpufu83c" />
              <span data-id="element-168" data-mp="269zihte7qxoe">Premium 6-in-1 Teaching System</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-169" data-mp="268og9y0f1xze">
              <CheckCircleIcon size={14} className="text-burgundy" data-id="element-170" data-mp="2b0ze8vblj9pb" />
              <span data-id="element-171" data-mp="2fzsuuwm6jgtp">5 strategic bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-172" data-mp="2fzamj1m8tc5f">
              <CheckCircleIcon size={14} className="text-burgundy" data-id="element-173" data-mp="2kydt4qhvfqfi" />
              <span data-id="element-174" data-mp="2l0qc96zd86u5">Immediate access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}